import PageProtectedLayout from "../../components/Page/PageProtectedLayout.jsx";
import SectionDashboardBlood from "../../components/Section/SectionDashboardBlood.jsx";
import LabfinderSection from "./LabfinderSection.jsx";

import { useTheme } from "@mui/material";

export default function LabfinderWelcome() {

    const theme = useTheme();
    const isLight = theme.palette.mode === "light";

    // Define colors once
    const sectionColors = {
        section1: isLight ? "grey.C400" : "greydark.C900",
        section2: isLight ? "grey.C400" : "greydark.C900",
        section3: isLight ? "grey.C400" : "greydark.C975",
        section4: isLight ? "grey.C500" : "greydark.C970",
    };

    // Define sections as an array
    const sections = [
        { color: sectionColors.section1, content: <LabfinderSection /> },
        { color: sectionColors.section2, content: null },
        { color: sectionColors.section3, content: null },
        { color: sectionColors.section4, content: null },
    ];

return (

    <PageProtectedLayout
      
      headline="CERTIFIED LABORATORIES - "
      specify="FINDER"

      >

      {/* Main Page Content */}
      <div>
        <SectionDashboardBlood
          colorContainer="transparent"
          sections={sections}
          gap={0}      // spacing between sections
          padding={0}  // padding inside the container
        />
      </div>
      
    </PageProtectedLayout>

  );
}